'use strict';

// stylesheet import
import '../sass/main.sass';
// import '../scss/main.scss';

import { createApp } from 'vue';
// import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import App from './vue/app.vue';
import { IntersectionObserverToggleClass } from './modules/class-intersection-observer-toggleclass.js';
import { IsLegacyIE } from './modules/checking-legacy-ie.js';
import { FindOS } from './modules/checking-os.js';
import { FindBrowser } from './modules/checking-browser.js';
import { ScrollTop } from './modules/scroll-top.js';
import { DrawerNavigation } from './modules/drawer-navigation.js';
import Masonry from 'masonry-layout';
const $ = require('jQuery');
// const Vue = require('vue');

// Vue.js
const app = createApp(App);
  app.mount('#app');

// jQuery
$(function() {
  
  // dropdown menu
  $('.js-dropdown-menu-button').each(function() {
    $(this).on('click', function() {
      $(this).next('.js-dropdown-menu-list').slideToggle();
      $(this).toggleClass('__close');
    });
  });
  
});

// swiper (carousel slide)
// const swiper = new Swiper('.swiper', {
//   slidesPerView: 2,
//   spaceBetween: 10,
//   breakpoints: {
//     545: {
//       slidesPerView: 3
//     },
//     769: {
//       slidesPerView: 4
//     }
//   },
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   }
// });

// GSAP
gsap.registerPlugin(ScrollTrigger);
// fadein
ScrollTrigger.batch('.js-animation-fadein', {
  onEnter: batch => gsap.fromTo(batch,
    {
      y: 50,
      autoAlpha: 0
    },
    {
      y: 0,
      autoAlpha: 1,
      delay: 0.6,
      duration: 1.2,
      ease: 'power2.out',
      stagger: 0.2
    }
  ),
  once: true
});
// left slidein
ScrollTrigger.batch('.js-animation-slidein-left', {
  onEnter: batch => gsap.fromTo(batch,
    {
      x: -50,
      autoAlpha: 0
    },
    {
      x: 0,
      autoAlpha: 1,
      delay: 0.6,
      duration: 1.2,
      ease: 'power2.out',
      stagger: 0.2
    }
  ),
  once: true
});
// right slidein
ScrollTrigger.batch('.js-animation-slidein-right', {
  onEnter: batch => gsap.fromTo(batch,
    {
      x: 50,
      autoAlpha: 0
    },
    {
      x: 0,
      autoAlpha: 1,
      delay: 0.6,
      duration: 1.2,
      ease: 'power2.out',
      stagger: 0.2
    }
  ),
  once: true
});

// Intersection Observer
new IntersectionObserverToggleClass({
  selector: '.observe_target', 
  className: 'observed', 
  toggle: true
});

// checking legacy IE
// IsLegacyIE();

// checking OS
FindOS();

// checking browser
FindBrowser();

// scroll top
ScrollTop();

// drawer navi
DrawerNavigation();

// Masonry
const masonry01 = new Masonry('.js-masonry-container-01', {
  itemSelector: '.js-masonry-item-01',
  gutter: 10,
  horizontalOrder: true
});
const masonry02 = new Masonry('.js-masonry-container-02', {
  itemSelector: '.js-masonry-item-02',
  gutter: 10,
  horizontalOrder: true
});
const masonry03 = new Masonry('.js-masonry-container-03', {
  itemSelector: '.js-masonry-item-03',
  gutter: 10,
  horizontalOrder: true
});
const masonry04 = new Masonry('.js-masonry-container-04', {
  itemSelector: '.js-masonry-item-04',
  gutter: 10,
  horizontalOrder: true
});